import { getCookie } from '@workspace/gtm/core';

/**
 * The marketing website (Sanity) classifies where the visitor came from and
 * keeps it in GTM's `traffic*` cookies on the shared parent domain. A visitor
 * reaching the app from there has the marketing site as `document.referrer`,
 * so the original referrer (e.g. Google organic) only survives in those cookies.
 *
 * The app's GTM container rewrites them on load (as '<our domain> / referral'),
 * so the middleware copies them into this cookie before any app script runs.
 */
export type EntryTraffic = {
  source?: string;
  medium?: string;
};

export const ENTRY_TRAFFIC_COOKIE_NAME = 'pdap_entry_traffic';

// Note: written by the marketing website's GTM container
export const MARKETING_TRAFFIC_COOKIES = {
  source: 'trafficSource',
  medium: 'trafficMedium',
} as const;

// Note: values are only matched against classification rules, never rendered
export function readEntryTrafficCookie(): EntryTraffic | null {
  try {
    const raw = getCookie(ENTRY_TRAFFIC_COOKIE_NAME);
    return raw ? (JSON.parse(raw) as EntryTraffic) : null;
  } catch {
    return null;
  }
}
